import { render } from "./LinearScale.vue?vue&type=template&id=210daf5d"
import script from "./LinearScale.vue?vue&type=script&lang=js"
export * from "./LinearScale.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__